import { Box, Grid, Typography } from '@mui/material';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { Gridstyles } from '../Investments/investor-application';
import { KeyValue } from './contributor';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import {
  POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE,
  poaValidationDate,
  USER_ROLES,
} from '../../utils/constant';
import {
  checkIfApplicationIsIndividualPOA,
  checkValidationBasedOnDate,
  checkIfDistributorIndividual,
  checkSupportLogin,
} from '../../utils/utilityFunctions';
import { POAAuthorizedSignatry } from '../NonIndividualApplicationDetails/AuthorisedSignatories';

export default function DistributorDetails({
  application,
}: {
  application: ApplicationProps;
}): JSX.Element {
  const { auth } = useSelector((store: RootStateType) => store);
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography
                component="h2"
                sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
                RM/Distributor Details
              </Typography>
            </Grid>

            <Gridstyles sx={{ width: '100%' }}>
              <Grid
                item
                container
                pt={1}
                pb={5}
                rowSpacing={6}
                columnSpacing={13}
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start">
                {application.distributor_id && (
                  <>
                    {checkIfDistributorIndividual(application?.distributor?.type) ? (
                      <>
                        <KeyValue
                          title={'Distributor ARN Code'}
                          description={application?.distributor?.arnCode}
                        />
                        <KeyValue
                          title={'Distributor Name'}
                          description={application?.distributor?.name}
                        />
                        <KeyValue
                          title={'Distributor Email'}
                          description={application?.distributor?.user?.email}
                        />
                        <KeyValue
                          title={'Distributor Mobile No'}
                          description={application?.distributor?.user?.phone}
                        />
                      </>
                    ) : (
                      <>
                        <KeyValue
                          title={'Distributor ARN Code'}
                          description={application?.distributor?.arnCode}
                        />
                        <KeyValue
                          title={'Distributor Name'}
                          description={application?.distributor?.name}
                        />
                      </>
                    )}
                  </>
                )}
                {application.subdistributorId && (
                  <>
                    <KeyValue
                      title={'Distributor Sales RM Name'}
                      description={application?.subDistributor?.user?.firstName}
                    />
                    <KeyValue
                      title={'Distributor Sales RM Email ID'}
                      description={application?.subDistributor?.user?.email}
                    />
                    <KeyValue
                      title={'Distributor Sales RM Mobile No'}
                      description={application?.subDistributor?.user?.phone}
                    />
                  </>
                )}
                {auth?.role !== USER_ROLES.INVESTOR && (
                  <KeyValue title={'Maker Email ID'} description={application?.rm?.user?.email} />
                )}
                <KeyValue
                  title={'Distribution/ Placement Fees'}
                  description={`Distributor Commission @ ${
                    application?.distMangementFee ? application?.distMangementFee : 0
                  }% of management fees as permitted under SEBI Regulations`}
                />
                <KeyValue
                  title={'Distribution Commission: Performance Fees'}
                  description={`Distributor Commission @ ${
                    application?.distPerformanceFee ? application?.distPerformanceFee : 0
                  }% of Performance Fees as permitted under SEBI Regulations`}
                />
                {application?.rmName && (
                  <KeyValue title={'RM Name'} description={application?.rmName} />
                )}
                {application?.rmEmail && (
                  <KeyValue title={'RM Email Id'} description={application?.rmEmail} />
                )}
                {application?.rmMobile && (
                  <KeyValue title={'RM Mobile No'} description={application?.rmMobile} />
                )}
                <KeyValue title={'Additional RM Email Id'} description={application?.rmEmailId} />
                {application?.supportSubdistributor?.user.id &&
                  !checkSupportLogin(
                    Number(auth.id),
                    Number(application?.supportSubdistributor?.user.id)
                  ) && (
                    <>
                      <KeyValue
                        title={'CXO Name'}
                        description={application?.supportSubdistributor?.user?.firstName}
                      />
                      <KeyValue
                        title={'CXO Email'}
                        description={application?.supportSubdistributor?.user?.email}
                      />
                      <KeyValue
                        title={'CXO Mobile No'}
                        description={application?.supportSubdistributor?.user?.phone}
                      />
                    </>
                  )}
              </Grid>
            </Gridstyles>
          </Grid>
          {application?.poaauthorisedsignatories?.length >= 0 &&
            checkValidationBasedOnDate(application.createdAt || '', poaValidationDate) &&
            checkIfApplicationIsIndividualPOA(application) &&
            POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE && (
              <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
                <Typography sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
                  Authorised Signatories
                </Typography>
                {application?.poaauthorisedsignatories?.length === 0 ? (
                  <Grid
                    xs={12}
                    sm={12}
                    sx={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: 'common.black',
                      textAlign: 'center',
                      my: 3,
                    }}>
                    No Authorised Signatories
                  </Grid>
                ) : (
                  <POAAuthorizedSignatry />
                )}
              </Grid>
            )}
        </Box>
      </Box>
    </>
  );
}
